<template>
  <div class="Contact">
    <div class="wrapper">
      <h1>Contact Me.</h1>
      <h2>I'm always happy to chat.</h2>
    
      <div class="form">
        <form @submit="submitForm" novalidate>
          <div :class="[{error:!nameValid}, 'field']">
            <label for="name">Name <span>*</span></label> 
            <input type="text" name="name" id="name" placeholder="Your Name" v-model="name" />
            <div class="errorMsg" v-if="!nameValid">Name required</div>
          </div>

          <div :class="[{error:!emailValid}, 'field']">
            <label for="email">Email <span>*</span></label> 
            <input type="email" name="email" id="email" placeholder="Your Email" v-model="email" />
            <div class="errorMsg" v-if="!emailValid">Valid email required</div> 
          </div>

          <div class="field">
            <label for="phone">Phone</label> 
            <input type="text" name="phone" id="phone" placeholder="Phone No." v-model="phone" /> 
          </div>

          <div class="field">
            <label for="message">What's on your mind?</label> 
            <textarea name="message" id="message" v-model="message"></textarea> 
          </div>

          <div class="field not">
            <label for="title">Title</label> 
            <input type="text" name="title" id="title" v-model="title" />
          </div>

          <footer>
            <button type="submit">
              <div v-if="inProgress" class="inprogress">
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              </div>
              Send
            </button>
            <transition name="vFade">
              <div class="success" v-if="formSuccess">
                <div class="check"><span></span><span></span></div>
                Submission Received
              </div>
              <div class="error" v-if="formError">
                Error Submitting
              </div>
            </transition>
          </footer>

        </form>
      </div>
      
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Contact',
  components: {
    Footer
  },
  data() {
    return {
      inProgress: false,
      formValid: false,
      name: '',
      email: '',
      phone: '',
      message: '',
      title: '', // using as honeypot
      nameValid: true,
      emailValid: true,
      formSuccess: false,
      formError: false
    }
  },
  watch: {
    name() {
      this.validateName()
    },
    email() {
      this.validateEmail()
    }
  },
  methods: {
    validateName() {
      if (!this.inProgress) {
        if (this.name != '') {
          this.nameValid = true
        } else {
          this.nameValid = false
        }
      }
    },
    validateEmail() {
      if (!this.inProgress) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          this.emailValid = true
        } else {
          this.emailValid = false
        }
      }
    },
    submitForm(e) {
      e.preventDefault()
      this.validateName()
      this.validateEmail()

      if (this.nameValid && this.emailValid && this.title == '') {
        // console.log('form valid')
        this.inProgress = true
        
        axios
          .post(
            "https://submit-form.com/Zij25AzgGa9KcRYTcf1Lt",
            {
              name: this.name,
              email: this.email,
              phone: this.phone,
              message: this.message
            }
          )
          .then(response => {
            console.log(response)
            this.name = ''
            this.email = ''
            this.phone = ''
            this.message = ''
            this.nameValid = true
            this.emailValid =  true
            setTimeout(() => {
              this.inProgress = false
              this.formSuccess = true
            }, 50);
            setTimeout(() => {
              this.formSuccess = false
            }, 7000)
          })
          .catch(e => {
            console.error(e)
            this.inProgress = false
            this.formError = true
            setTimeout(() => {
              this.formError = false
            }, 7000)
          })
        }
      }
  }
}
</script>

<style lang="scss" scoped>
  .Contact {
    background: #fff;
    padding: 160px 0 0 0;

    & .wrapper {
      margin: 0 auto;
      width: 1200px;
      padding: 0 0 80px 0;

      @media screen and (max-width: 1200px) {
        width: calc(100% - 80px);
      }
      @media screen and (max-width: $breakSmall) {
        width: calc(100% - 40px);
      }
    }

    & h1 {
      margin: 0 0 60px 0;
      text-align: center;
    }
    & h2 {
      text-align: center;
    }

    & .form {
      max-width: 600px;
      margin: 80px auto 0 auto;

      & .field {
        margin: 0 0 30px 0;

        & label {
          @include fontBodyBold();
          font-size: 12px;
          line-height: 15px;
          text-transform: uppercase;
          color: #000;
          display: block;
          margin: 0 0 4px 0;

          & span {
              @include fontBodyBold();
              padding: 0 0 0 5px;
              font-size: 15px;
          }
          @media screen and (max-width: $breakHandsetPortrait) {
              padding: 0 20px 0 0;
          }
        }
        & input, textarea {
          display: block;
          width: 100%;
          height: 40px;
          border: 1px solid $greyMed;
          background-color: #fff;
          @include fontBody();
          color: #333;
          padding: 0 10px;
          font-size: 15px;
          transition: all 300ms;

          @media screen and (max-width: $breakSmall) {
              font-size: 16px !important;
          }

          &:focus {
              border: 1px solid $greyDark;
              box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
          }
          &:hover {
              border: 1px solid $greyDark;
          }
        }
        & textarea {
          height: 100px;
          padding: 7px 10px;
        }
        &.error {
          & input, textarea {
            border: 1px solid $errorColor;
            background: $errorScreen;
            &:focus {
              border: 1px solid $errorDark;
            }
            &:hover {
              border: 1px solid $errorDark;
            }
          }
          & .errorMsg {
            display: block;
            color: $errorColor;
            font-size: 12px;
            line-height: 14px;
            margin: 4px 0 0 0;
          }
        }
        // honeypot
        &.not {
          position: absolute;
          top: -9000px;
          left: -9000px;
        }
      }
      & footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & button {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          background: $linkColor;
          color: #fff;
          text-decoration: none;
          padding: 12px 24px;
          text-align: center;
          text-transform: uppercase;
          border: none;
          @include fontBodyBold();
          font-size: 16px;
          cursor: pointer;
          border-radius: 2px;
          transition: all 200ms;

          & svg {
            width: 18px;
            height: 18px;
            fill: #fff;
            margin: 0 10px 0 0;
          }

          &:hover {
            background: $linkColorActive;
          }

          &.disabled {
            cursor: not-allowed;
            background: $greyMed;

            &:hover {
              background: $greyMed;
            }
          }
          // in progress
          & .inprogress {
            position: absolute;
            z-index: 10;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            cursor: not-allowed;
            background: $linkColorActive;
            color: $linkColorActive;

            &:hover {
              background: $linkColorActive;
            }

            & .spinner {
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 64px;
              text-align: center;
              line-height: 0;
            }

            & .spinner > div {
              width: 16px;
              height: 16px;
              background-color: #fff;

              border-radius: 100%;
              display: inline-block;
              -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
              animation: sk-bouncedelay 1.4s infinite ease-in-out both;
            }

            & .spinner .bounce1 {
              -webkit-animation-delay: -0.32s;
              animation-delay: -0.32s;
            }

            & .spinner .bounce2 {
              -webkit-animation-delay: -0.16s;
              animation-delay: -0.16s;
            }

            @-webkit-keyframes sk-bouncedelay {
              0%,
              80%,
              100% {
                -webkit-transform: scale(0);
              }
              40% {
                -webkit-transform: scale(1);
              }
            }

            @keyframes sk-bouncedelay {
              0%,
              80%,
              100% {
                -webkit-transform: scale(0);
                transform: scale(0);
              }
              40% {
                -webkit-transform: scale(1);
                transform: scale(1);
              }
            }
          }
          &:focus {
            outline: none;
          }
          // @media screen and (max-width: $breakSmall) {
          //   width: 100%;
          // }
        }
        & .success {
          color: $successColor;
          @include fontBodyBold;
          font-size: 16px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          text-align: right;

          & .check {
            width: 30px;
            height: 30px;
            border-radius: 15px;
            border: 1px solid $successColor;
            position: relative;
            margin: 0 10px 0 0;
            flex-shrink: 0;

            & span {
              position: absolute;
              height: 1px;
              background: $successColor;

              &:first-child {
                width: 8px;
                transform: rotate(50deg);
                top: 17px;
                left: 5px;
              }
              &:last-child {
                width: 16px;
                transform: rotate(-50deg);
                top: 13px;
                left: 9px;
              }
            }
          }
          @media screen and (max-width: $breakHandsetLandscape) {
            flex-direction: row-reverse;

            & .check {
              margin: 0 0 0 10px;
            }
          }
        }
        & .error {
          color: $errorColor;
          @include fontBodyBold;
          font-size: 16px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          text-align: right;

          &::before {
            content: '!';
            width: 30px;
            height: 30px;
            font-size: 20px;
            border-radius: 15px;
            border: 1px solid $errorColor;
            position: relative;
            margin: 0 10px 0 0;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
          @media screen and (max-width: $breakHandsetLandscape) {
            flex-direction: row-reverse;

            &::before {
              margin: 0 0 0 10px;
            }
          }
        }
      }
    }
    @media screen and (max-width: $breakSmall) {
      & .wrapper {
        padding: 0 0 40px 0;
      }
    }
  }
</style>